import { render } from "./template.html?vue&type=template&id=5ebbe5ec&scoped=true"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=5ebbe5ec&scoped=true&lang=scss"

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebbe5ec"]])

export default __exports__